import { create } from "zustand";

export const useMonitoreoPersonalStore = create((set) => ({
  estadisticasGeneral: null,
  estadisticasPersona: null,
  personalMonitoreo: null,
  interaccionesUnDia: null,
  fechaSeleccionada:null,
  type: "general",

  setEstadisticasGeneral: (estadisticas) => {
    set({ estadisticasGeneral: estadisticas });
  },

  setEstadisticasPersona: (estadisticas) => {
    set({ estadisticasPersona: estadisticas });
  },

  setPersonalMonitoreo: (personal) => {
    set({ personalMonitoreo: personal });
  },

  setType: (type) => {
    set({ type: type });
  },

  setInteraccionesUnDia: (interacciones, interaccionesBackOffice) => {
    if (interacciones == null) {
      set({ interaccionesUnDia: null });
    } else
      set({
        interaccionesUnDia: { interacciones, interacciones_backoffice: interaccionesBackOffice },
      });
  },

  setFechaSeleccionada: (fecha) =>{
    set({fechaSeleccionada:fecha})
  }

}));
